var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLuggage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 33.6v.3c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-.3M24.8 33.6v.3c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-.3M28 31.9c0 .9-.7 1.7-1.7 1.7H14.2c-.9 0-1.7-.7-1.7-1.7V13.1c0-.9.7-1.7 1.7-1.7h12.2c.9 0 1.7.7 1.7 1.7v18.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9 30.2c0 .7-.5 1.3-1.2 1.3h-8.9c-.7 0-1.2-.6-1.2-1.3v-7.8c0-.7.5-1.3 1.2-1.3h8.9c.7 0 1.2.6 1.2 1.3zM25.9 18c0 .7-.5 1.3-1.2 1.3h-8.9c-.7 0-1.2-.6-1.2-1.3v-3.3c0-.7.5-1.3 1.2-1.3h8.9c.7 0 1.2.6 1.2 1.3zM17.9 11.4V6.6M22.5 11.4V6.6M17.5 6.5H23"
}))));
export default SvgLuggage;